import {useMemo} from 'react'

import {getInjection} from '@runlab/di'

import type {IErrorReporter} from '@/src/ports/services/monitoring'

/**
 * Hook to access IErrorReporter
 * Provides dependency-injected error reporter service for UI components
 */
export const useErrorReporter = (): IErrorReporter => {
  return useMemo(() => getInjection('IErrorReporter'), [])
}
